'use strict';

import 'nls!./time_ago.json';

const UPDATE_INTERVAL = 60000;
const saTimeAgo = [
  '$translate',
  '$filter',

  function ($translate) {
    return {
      restrict: 'A',
      link: function postLink($scope, $element, $attr) {
        var addPrefix = false;
        var isProfile = angular.isDefined($attr.profile);
        var timer;

        function startTimeAgoTimer(time) {
          if (timer) {
            clearInterval(timer);
          }
          timer = setInterval(function () {
            setTimeAgo(time);
          }, UPDATE_INTERVAL);
        }

        function template(translationId, count, withPrefix) {
          var output = $translate.instant('TIMEAGO.' + translationId);

          if (addPrefix || withPrefix) {
            output = $translate.instant('MORE_THAN') + ' ' + output;
          }

          output = output.replace(/%d/i, Math.abs(Math.round(count)));
          return output;
        }

        function updateTimeAgo(time) {
          var limitTo = $attr.limitTo ? new Date($attr.limitTo) : null;
          var timeAgoPart;
          var timeAgo;
          var now;
          var seconds;
          var minutes;
          var hours;
          var days;
          var years;

          if (!time) {
            return;
          }

          time = new Date(time);
          now = new Date();

          if (limitTo && now > limitTo) {
            now = limitTo;
            addPrefix = true;
          }

          seconds = (now - time) / 1000;
          minutes = seconds / 60;
          hours = minutes / 60;
          days = hours / 24;
          years = days / 365;

          if (isProfile) {
            timeAgoPart = template('WEEKS', 2, true);
          } else {
            timeAgoPart = days > 13 && days < 30 && template('WEEKS', days / 7) ||
              days > 30 && days < 60 && template('MONTH', 1) ||
              days > 60 && days < 365 && template('MONTHS', days / 30) ||
              years < 2 && template('YEAR', 1) ||
              template('YEARS', years);
          }

          timeAgo = seconds < 59 && template('MOMENT', seconds) ||
            seconds >= 60 && seconds < 119 && template('MINUTE', 1) ||
            minutes < 59 && template('MINUTES', minutes) ||
            minutes >= 60 && minutes < 119 && template('HOUR', 1) ||
            hours >= 2 && hours < 24 && template('HOURS', hours) ||
            hours > 23 && hours < 48 && template('YESTERDAY', 1) ||
            days > 1 && days < 7 && template('DAYS', days) ||
            days > 6 && days < 13 && template('WEEK', days) ||
            timeAgoPart;

          return timeAgo;
        }

        function setTimeAgo(time) {
          $element.text(updateTimeAgo(time));
        }

        $attr.$observe('saTimeAgo', function (time) {
          var date;

          time = parseFloat(time);
          if (angular.isNumber(time)) {
            date = new Date(time * 1000);
            setTimeAgo(date);
            startTimeAgoTimer(date);
          }
        });

        $scope.$on('$destroy', function () {
          if (timer) {
            clearInterval(timer);
          }
        });
      }
    };
  }
];

export default saTimeAgo;



// WEBPACK FOOTER //
// ./app/src/directives/time_ago.js